<div class="collaboration-details-wrapper">
  <h3 nz-typography class="nfl-form-label">Create Collaboration</h3>

  <form nz-form [nzLayout]="'vertical'" [formGroup]="collaborationForm" class="form-grid">
    <div nz-row [nzGutter]="[16, 24]">
      <div nz-col class="gutter-row" [nzSpan]="12">
        <nz-form-item>
          <nz-form-label class="nfl-form-label" [nzNoColon]="true" [nzRequired]="true"> Name </nz-form-label>
          <nz-form-control [nzErrorTip]="nameErrorTemplate">
            <input nz-input formControlName="name" id="name" placeholder="Enter Collaboration Name" />
          </nz-form-control>
        </nz-form-item>
        <ng-template #nameErrorTemplate let-control>
          <div *ngIf="control?.errors?.['required']">Collaboration name is required</div>
          <div *ngIf="control?.errors?.['maxlength']">
            Collaboration name cannot exceed {{ control?.errors?.['maxlength'].requiredLength }} characters.
          </div>
          <div *ngIf="control?.errors?.['pattern']">
            Name should not contain any special characters and should have at least one alphabet.
          </div>
        </ng-template>
      </div>

      <div nz-col class="gutter-row" [nzSpan]="12">
        <nz-form-item>
          <nz-form-label class="nfl-form-label" [nzNoColon]="true" [nzRequired]="true"> Description </nz-form-label>
          <nz-form-control [nzErrorTip]="descriptionErrorTemplate">
            <textarea
              nz-input
              formControlName="description"
              id="description"
              placeholder="Enter Description"
              [nzAutosize]="{ minRows: 1, maxRows: 5 }"
            ></textarea>
          </nz-form-control>
        </nz-form-item>
        <ng-template #descriptionErrorTemplate let-control>
          <div *ngIf="control?.errors?.['required']">Description is required</div>
          <div *ngIf="control?.errors?.['maxlength']">
            Description cannot exceed {{ control?.errors?.['maxlength'].requiredLength }} characters.
          </div>
          <div *ngIf="control?.errors?.['pattern']">Please enter at least one alphabet or number</div>
        </ng-template>
      </div>
    </div>

    <div nz-row [nzGutter]="[16, 24]">
      <div nz-col class="gutter-row" [nzSpan]="24">
        <nz-form-item>
          <nz-form-label class="nfl-form-label" [nzNoColon]="true" [nzRequired]="true"> Objective </nz-form-label>
          <nz-form-control [nzErrorTip]="objectiveErrorTemplate">
            <textarea
              nz-input
              formControlName="objective"
              id="objective"
              placeholder="Enter Objective"
              [nzAutosize]="{ minRows: 4, maxRows: 8 }"
            ></textarea>
          </nz-form-control>
        </nz-form-item>
        <ng-template #objectiveErrorTemplate let-control>
          <div *ngIf="control?.errors?.['required']">Objective is required</div>
          <div *ngIf="control?.errors?.['maxlength']">
            Objective cannot exceed {{ control?.errors?.['maxlength'].requiredLength }} characters.
          </div>
          <div *ngIf="control?.errors?.['pattern']">Please enter at least one alphabet or number</div>
        </ng-template>
      </div>
    </div>
  </form>
</div>
